//find every element with data-rotate attribute
var elements = document.querySelectorAll('[data-rotate]');
// check if they have transform property, if so add to beginning of transform: rotate([value]deg)

window.onload = () => {

}

let toggle = document.querySelector("#toggle");
let expander = document.querySelector(".expander");


//find every document.querySelectorAll(".cart_attr.active") element
//get their parent's data-option-type. accumulate an object with the data-option-type as key and the textContent of the element as value
const getProps = () => {
    let props = {};
    document.querySelectorAll(".cart_attr.active").forEach(el => {
        let type = el.parentNode.parentNode.getAttribute("data-option-type");
        let value = el.textContent;
        props[type] = value;
    });
    return props;
}

const buttonListener = (e) => {
    e.preventDefault();
    let target = e.target.closest("button");
    let variant = target.getAttribute('data-add-variant');
    let quantity = target.getAttribute('data-add-q');
    let props = getProps();
    processCartUpdate(variant,quantity, props);
}

const cartQuantityListener = (e) => {
    e.preventDefault();
    let variant = e.target.closest(".cart-item").getAttribute('data-variant');
    let initialQuantity = parseInt(e.target.getAttribute('data-initial-q'));
    let quantity = parseInt(e.target.value) - initialQuantity;
    // console.log({cartItem:e.target.closest(".cart-item"),variant,quantity});
    processCartUpdate(variant,quantity);
}

const installButtonListeners = (e) => {
    document.querySelectorAll('[data-add-variant]').forEach(anchor => {
        //check if the element has an event listener, if so remove it
        anchor.removeEventListener('click', buttonListener);
        anchor.addEventListener('click', buttonListener);
    });
    //add back handlers from other file
    document.querySelectorAll("[data-a11y-toggle]").forEach(anchor => {
        //check if the element has an event listener, if so remove it
        anchor.removeEventListener('click', window.handlers.modalToggleHandler);
        anchor.addEventListener('click', window.handlers.modalToggleHandler);
    })
    //add quantity listeners to all cart .item-quantity elements
    document.querySelectorAll('.item-quantity').forEach(input => {
        //check if the element has an event listener, if so remove it
        input.removeEventListener('input', cartQuantityListener);
        input.addEventListener('input', cartQuantityListener);
    });

}

installButtonListeners();

  //for any link named .jump, scroll to the target smoothly
document.querySelectorAll('.jump').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        let href = this.getAttribute('href');
        if(href.indexOf("#") > -1){
            e.preventDefault();
            const targetElement = document.querySelector(this.getAttribute('href'));
            const yOffset = -1*window.innerWidth*0.135; // Adjust this value to set the desired offset
            const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
        }
    });
});

//save the cart in window.object and update the cart count in the header
window.cart_reset = (data,variant) => {
    if(data && data?.sections['cart-drawer'] || data && data?.sections['cart-page']){
        // document.querySelector('#cart-drawer-section').innerHTML = data.sections['cart-drawer'];
        //instead of the line above, please take the inner ".cart-items" inside data.sections['cart-drawer'] and insert it into #cart-drawer-section's .cart-items innerHTML
        let cartDrawer = document.querySelector('#cart-drawer-section #cart-drawer');
                if(cartDrawer){
                    cartDrawer.innerHTML = new DOMParser()
                                .parseFromString(data.sections['cart-drawer'], 'text/html')
                                .querySelector('#cart-drawer').innerHTML;
                    //if variant, show only the cart item with data-variant match
                    if(variant && false){
                        let cartItems = cartDrawer.querySelectorAll('.cart-item');
                        cartItems.forEach(item => {
                            if(item.getAttribute('data-variant') != variant){
                                item.remove();
                            }
                        });
                    }
                }
            let cartPage = document.querySelector('.cart-page');
                if(cartPage){
                    cartPage.innerHTML = new DOMParser()
                                .parseFromString(data.sections['cart-page'], 'text/html')
                                .querySelector('.cart-page').innerHTML;
                }

        if(!dialogs["cart-drawer-wrapper"].shown){
            toggleModal("cart-drawer-wrapper")
        }
    }
    fetch("/cart.js").then(response => response.json()).then(data => {
        window.cart = data;
        // console.log("cart",window.cart)
        document.querySelectorAll('#cart-count').forEach(el => {
            el.innerText = data.item_count;
        });
    });
    installButtonListeners();
}

cart_reset();

// a scheme based on the attribute "data-add-variant".
//this adds or removes variants from the cart. if no attribute "data-add-q" is present, it will add 1 of the variant to the cart.
//if data-add-q is present and equals 0, it will remove the variant from the cart entirely. if it's -1 or below, it will remove that many of the variant from the cart.
//if it's 1 or above, it will add that many of the variant to the cart.

const changeCart = async (variant,quantity) => await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ id: variant, quantity, sections: "cart-drawer,cart-count,cart-page" })
    }).catch((error) => {
        console.error('Error:', error);
    }).then(response => response.json()).then(data => {
        console.log("cart changed",data)
        cart_reset(data,variant);
    });

const addCart = async (variant,quantity,properties={}) => await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({items: [{ id: variant, quantity, properties }], sections: "cart-drawer,cart-count,cart-page"})
    }).catch((error) => {
        console.error('Error:', error);
    }).then(response => response.json()).then(data => {
        console.log("cart added",data)
        cart_reset(data,variant);
    });

const processCartUpdate = (variant,quantity,props) => {
    let variantAlreadyInCart = cart.items.find(item => item.variant_id == variant);
    if (variantAlreadyInCart) {
        if (quantity === "0") {
            quantity = 0;
        } else if (!quantity) {
            quantity = 1;
        }
        let newQuantity = quantity === 0 ? 0 : parseInt(variantAlreadyInCart.quantity) + parseInt(quantity);
        // console.log("newQuantity",newQuantity)
        changeCart(variant,newQuantity);
    } else {
        if (!quantity || quantity === "0") {
            quantity = 1;
        }
        console.log("adding to cart",variant,quantity,props)
        addCart(variant,quantity,props);
    }
}

// document.querySelector(".cart-toggle").click()

//search all links in both the .menu-links and .main-nav elements
//if the current url matches the href of the link, add the class .active to the link
document.querySelectorAll('.menu-links a, .main-nav a').forEach(anchor => {
    // console.log(anchor.getAttribute("href")=== window.location.pathname)
    if (anchor.getAttribute("href") == window.location.pathname) {
        anchor.classList.add('current-link');
    }
});

document.addEventListener("DOMContentLoaded", function() {
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazyload"));
    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("lazyload");
                    lazyImage.classList.add("lazyloaded");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Fallback for browsers that do not support IntersectionObserver
        lazyImages.forEach(function(lazyImage) {
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove("lazyload");
            lazyImage.classList.add("lazyloaded");
        });
    }
    document.getElementById("menu-wrapper").classList.add("ready");
    document.querySelector(".image-banner-announcement")?.classList.add("ready");

    //for all flavor-outline elements, add this "points" attr: points="285.19 131.38 277.99 125.29 283.35 117.52 275.58 112.16 280.16 103.91 271.9 99.33 275.65 90.67 266.99 86.93 269.86 77.94 260.88 75.06 262.86 65.84 253.63 63.86 254.7 54.48 245.32 53.41 245.47 43.98 236.03 43.83 235.25 34.43 225.85 35.21 224.15 25.93 214.87 27.63 212.27 18.56 203.2 21.16 199.72 12.39 190.95 15.86 186.63 7.47 178.24 11.8 173.11 3.87 165.19 8.99 159.31 1.61 151.93 7.48 145.36 .71 138.59 7.28 131.38 1.18 125.29 8.38 117.52 3.02 112.16 10.79 103.91 6.21 99.33 14.46 90.67 10.72 86.93 19.38 77.94 16.51 75.06 25.49 65.84 23.51 63.86 32.74 54.48 31.67 53.41 41.04 43.98 40.9 43.83 50.33 34.43 51.12 35.21 60.52 25.93 62.22 27.63 71.5 18.56 74.1 21.16 83.17 12.39 86.65 15.86 95.42 7.47 99.74 11.79 108.13 3.87 113.25 8.99 121.18 1.61 127.05 7.48 134.44 .71 141.01 7.28 147.78 1.18 154.98 8.38 161.08 3.02 168.85 10.79 174.21 6.21 182.46 14.46 187.04 10.72 195.7 19.38 199.44 16.51 208.43 25.49 211.31 23.51 220.53 32.74 222.51 31.67 231.89 41.04 232.96 40.9 242.39 50.33 242.54 51.12 251.94 60.52 251.16 62.22 260.44 71.5 258.74 74.1 267.81 83.17 265.21 86.65 273.98 95.42 270.51 99.74 278.89 108.13 274.57 113.25 282.5 121.18 277.38 127.05 284.76 134.44 278.89 141.01 285.66 147.78 279.09 154.98 285.19 161.08 277.99 168.85 283.35 174.21 275.58 182.46 280.16 187.04 271.9 195.7 275.65 199.44 266.99 208.43 269.86 211.3 260.88 220.53 262.86 222.51 253.63 231.89 254.7 232.96 245.32 242.39 245.47 242.54 236.03 251.94 235.25 251.16 225.85 260.44 224.15 258.74 214.87 267.81 212.27 265.21 203.2 273.98 199.72 270.5 190.95 278.89 186.63 274.57 178.24 282.5 173.11 277.38 165.19 284.76 159.32 278.89 151.93 285.66 145.36 279.09 138.59 285.19 131.38"
    document.querySelectorAll(".flavor-outline").forEach(el => {
        // el.setAttribute("points", "285.19 131.38 277.99 125.29 283.35 117.52 275.58 112.16 280.16 103.91 271.9 99.33 275.65 90.67 266.99 86.93 269.86 77.94 260.88 75.06 262.86 65.84 253.63 63.86 254.7 54.48 245.32 53.41 245.47 43.98 236.03 43.83 235.25 34.43 225.85 35.21 224.15 25.93 214.87 27.63 212.27 18.56 203.2 21.16 199.72 12.39");
    });


    
});

// //for any element with class .browser, add class safari if the browser is safari
// if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
//     document.querySelectorAll('.browser').forEach(el => {
//         el.classList.add('safari');
//     });
// }


const initElements = (dataAttr, baseSelector, cloneClass) => {
    document.querySelectorAll(`[${dataAttr}]`).forEach((el, k) => {
        let data = JSON.parse(el.getAttribute(dataAttr));
        // console.log(data);
        let base = document.querySelector(baseSelector);
        
        // Ensure the parent element has relative positioning
        el.style.position = "relative";
        data.forEach((d, j) => {
            let clone = base.cloneNode(true);
            clone.classList.add(cloneClass);
            clone.style.position = "absolute";
            clone.style.width = d[0] + "%";
            clone.style.left = d[2][0] + "%";
            clone.style.top = d[2][1] + "%";

            // Handle gradient or solid fill
            if (d[1].length > 1) {
                let defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
                let gradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
                gradient.setAttribute("id", `grad-${j}-${dataAttr}`);
                d[1].forEach((color, i) => {
                    let stop = document.createElementNS("http://www.w3.org/2000/svg", "stop");
                    stop.setAttribute("offset", `${(i * 100) / (d[1].length - 1)}%`);
                    stop.setAttribute("stop-color", color);
                    gradient.appendChild(stop);
                });
                defs.appendChild(gradient);
                clone.appendChild(defs);
                clone.style.fill = `url(#grad-${j}-${dataAttr})`;
            } else {
                clone.style.fill = d[1][0];
            }

            // Handle rotation if specified
            if (d[3]) {
                clone.querySelector("path").style.transform = `rotate(${d[3]}deg)`;
            }

            el.appendChild(clone);
        });
    });
};

document.addEventListener("DOMContentLoaded", function() {
    const ignoredSections = ["shopify-section-footer","shopify-section-marquee",]
    //start scrollbar stuff
    let sections = document.querySelectorAll("#MainContent > .shopify-section");
    //filter out sections with class names from ignoredSections
    sections = Array.from(sections).filter(section => {
        let classList = Array.from(section.classList);
        return !classList.some(className => ignoredSections.includes(className));
    });
    let totalSections = 8;//sections.length;
    //for each section add a clone of #scrollbar .scrollbar-note
    let scrollbar = document.querySelector("#scrollbar");
    let scrollbarNote = scrollbar.querySelector(".scrollbar-note");
    scrollbarNote.querySelector("path").setAttribute("fill", "url(#first-gradient)");
    let main = document.getElementById("MainContent");
    for(let i = 0; i < totalSections-1; i++){
        let scrollbarNoteClone = scrollbarNote.cloneNode(true);
        scrollbarNoteClone.classList.add("scrollbar-note-clone");
        // create gradient def
        let defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
        let gradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
        gradient.setAttribute("id", `grad-${i}-scrollbar`);
        let colors = note_colors[(i+1) % note_colors.length];
        colors.forEach((color, j) => {
            let stop = document.createElementNS("http://www.w3.org/2000/svg", "stop");
            stop.setAttribute("offset", `${(j * 100) / (colors.length - 1)}%`);
            stop.setAttribute("stop-color", color);
            gradient.appendChild(stop);
        });
        defs.appendChild(gradient);
        scrollbarNoteClone.querySelector("svg").appendChild(defs);
        scrollbarNoteClone.querySelector("path").setAttribute("fill", `url(#grad-${i}-scrollbar)`);
        scrollbar.appendChild(scrollbarNoteClone);
        // scrollbarNoteClone.querySelector("path").style.fill = ["red","green","yellow","purple"][i%5];
    }
    //add ready class to scrollbar
    scrollbar.classList.add("ready");
    //setup an intersection observer to observe all the sections, and give the corresponding .scrollbar-note-clone the class .active
    let options = {
        root: main,
        rootMargin: '0px',
        threshold: 0.05
    }
    let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let index = Array.from(sections).indexOf(entry.target);
                // console.log("Intersecting "+entry.target.id+" section");
                // Array.from(entry.target.parentNode.children).forEach((child, i) => { child.classList.remove("active") });
                if(main.scrollTop === 0){
                    sections[0].classList.add("active");
                    // scrollbar.querySelector(".scrollbar-note").classList.add("active");
                } else {
                    console.log("entered "+entry.target.id+" section");
                    entry.target.classList.add("active");
                    // scrollbar.querySelectorAll(".scrollbar-note").forEach((note, i) => {
                    //     if(i == index){
                    //         note.classList.add("active");
                    //     }else{
                    //         note.classList.remove("active");
                    //         note.classList.remove("active-adjacent");
                    //         if(i+1 == index || i-1 == index){
                    //             note.classList.add("active-adjacent");
                    //         }
                    //     }
                    // });
                }
            } else {
                entry.target.classList.remove("active");
            }
        });
    }, options);
    //observe all sections
    sections.forEach(section => {
        observer.observe(section); 
    });
    let notes = document.querySelectorAll(".scrollbar-note");
    let currentNote = 0;

    if(window.innerWidth/window.innerHeight> 2.23){
        totalSections = 5
    }

    //set active note based on scroll position
    let scrollPosition = main.scrollTop/main.scrollHeight;
    let startingNoteIndex = Math.floor(scrollPosition * totalSections);
    let scrollHeight = main.scrollHeight;
    let clientHeight = main.clientHeight;

    notes[startingNoteIndex].classList.add("active");

    //non-obscructive scroll listener. separate entire scrollable area in main and split into 6 sections. set the nth note-clone to active and unset others
    main.addEventListener("scroll", function() {
        let scrollTop = main.scrollTop;
        let scrollPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;
        let index = Math.min(Math.floor(scrollPercent / (100 / totalSections)),totalSections - 1);
        //add active class to the current section
        // notes.forEach((note, i) => {
        //     note.classList.remove("active");
        // });
        if(index !== currentNote){
            notes[currentNote].classList.remove("active");
            notes[index].classList.add("active");
            currentNote = index;
            console.log(index)
        }
    });


    //end 

    //when clicking on a shopify-section, console.log the percent offset of x and y
    document.querySelectorAll(".shopify-section").forEach(section => {
        section.addEventListener("click", function(e) {
            let rect = section.getBoundingClientRect();
            let x = e.clientX - rect.left;
            let y = e.clientY - rect.top;
            let percentX = (x / rect.width) * 100;
            let percentY = (y / rect.height) * 100;
            console.log(`[${percentX.toFixed(2)},${percentY.toFixed(2)}]`);
        });
    });
   
    // initStars();
    // initNotes();
    // document.addEventListener("DOMContentLoaded", function () {
    if(window.innerWidth > 768){
        initElements("data-stars", ".star", "star-clone");
        initElements("data-notes", ".note", "note-clone");
        initElements("data-doublenotes", ".notes", "notes-clone");
    } else {
        initElements("data-mobile-stars", ".star", "star-clone");
        initElements("data-mobile-notes", ".note", "note-clone");
        initElements("data-mobile-doublenotes", ".notes", "notes-clone");
    }
    let mobileSize = window.innerWidth < 768;
    //when window size passes threshold of 768, remove mobile stars and notes and add desktop stars and notes
    window.addEventListener("resize", function() {
        if(mobileSize && window.innerWidth > 768){
            console.log("switching to desktop");
            document.querySelectorAll(".star-clone").forEach(el => el.remove());
            document.querySelectorAll(".note-clone").forEach(el => el.remove());
            document.querySelectorAll(".notes-clone").forEach(el => el.remove());
            initElements("data-stars", ".star", "star-clone");
            initElements("data-notes", ".note", "note-clone");
            initElements("data-doublenotes", ".notes", "notes-clone");
            mobileSize = false;
        } else if(!mobileSize && window.innerWidth < 768){
            console.log("switching to mobile");
            document.querySelectorAll(".star-clone").forEach(el => el.remove());
            document.querySelectorAll(".note-clone").forEach(el => el.remove());
            document.querySelectorAll(".notes-clone").forEach(el => el.remove());
            initElements("data-mobile-stars", ".star", "star-clone");
            initElements("data-mobile-notes", ".note", "note-clone");
            initElements("data-mobile-doublenotes", ".notes", "notes-clone");
            mobileSize = true;
        }
    },{passive:true});

        
    // });
    const listenForScrollsOnTastingNotes = (e) => {
        e.preventDefault();
        console.log("We scrolled!!")
        for(let i=1;i<7;i++){
            dialogs[`tasting-note-${i}`].hide();
        }
        main.removeEventListener("scroll", listenForScrollsOnTastingNotes);
    };
    document.querySelectorAll(".tasting-note-key").forEach(el => el.addEventListener("click", function(e) {
        setTimeout(() => {
            main.addEventListener("scroll", listenForScrollsOnTastingNotes);
        }, 200);
    }));

    // on click back-to-top, scroll to top of page
    document.querySelectorAll(".back-to-top").forEach(el => {
        el.addEventListener("click", function(e) {
            e.preventDefault();
            if (document.querySelector(".qr-video-section-wrapper")) {
                window.location.href = "/";
            } else {
                main .scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
    });


    //for every .shopify-section, adopt the child's background color
    document.querySelectorAll(".shopify-section").forEach(section => {
        let child = section.querySelector(".shopify-section > *");
        if (child) {
            let bgColor = window.getComputedStyle(child).backgroundColor;
            section.style.backgroundColor = bgColor;
        }
    });
});

// document.addEventListener('keydown', (e) => {
//     if (e.key === 'Tab') {
//         document.body.classList.add('keyboard-navigation');
//     }
// });

// document.addEventListener('mousedown', () => {
//     document.body.classList.remove('keyboard-navigation');
// });

//if customer_posted=true in the URL, add .customer-posted to .newsletter-form
if (window.location.href.indexOf('customer_posted=true') > -1) {
    document.querySelector(".newsletter-form").classList.add("customer-posted");
    document.querySelector(".newsletter-form input[type='email']").setAttribute("placeholder", "Thanks for signing up!");
}


//passive scroll listener on MainContent. Save y to local storage. on refresh, scroll to y
const isQrPage = document.body.classList.contains("page-qrcode");
let scrollY = localStorage.getItem("scrollY");
let scrollYTime = localStorage.getItem("scrollYTime");
if(scrollYTime && (new Date().getTime() - scrollYTime < 1000*60*60*2)){
    scrollY = parseInt(scrollY);
}
const navType = performance.getEntriesByType('navigation')[0]?.type ?? performance.navigation?.type;
const isBackNav = navType === 'back_forward' || navType === 2 || navType === 'reload' || navType === 1;
if(scrollY && !isQrPage && isBackNav){
    if((new Date().getTime() - scrollYTime < 1000*60*60*2)){
        document.getElementById("MainContent").scrollTo(0,scrollY);
    } else {
        localStorage.removeItem("scrollY");
    }
}
document.getElementById("MainContent").addEventListener("scroll", function() {
    if(isQrPage) return;
    localStorage.setItem("scrollY", this.scrollTop);
    localStorage.setItem("scrollYTime", new Date().getTime());
}, {passive:true});
//for every element with data-rotate attribute, rotate it by the value of the attribute